import React from 'react'
import { useMainPageImpactMetricCardStyles } from './main-page-impact-metric-card.styles'

export type MainPageImpactMetricCardProps = {
  value: React.ReactNode
  label: React.ReactNode
  imageSrc: string
  imageAlt?: string
}

export const MainPageImpactMetricCard: React.FC<
  MainPageImpactMetricCardProps
> = ({ value, label, imageSrc, imageAlt = '' }) => {
  const classes = useMainPageImpactMetricCardStyles()

  return (
    <article className={classes.card}>
      <div className={classes.imageWrap}>
        <img className={classes.image} src={imageSrc} alt={imageAlt} />
      </div>
      <div className={classes.body}>
        <p className={classes.value}>{value}</p>
        <p className={classes.label}>{label}</p>
      </div>
    </article>
  )
}
